import { lock, unlock } from 'tua-body-scroll-lock'

const navigation = document.querySelector('.navigation')
const navigationScroll = document.querySelector('.navigation__scroll-area')
const searchScroll = document.querySelector('.navigation__search-results')
const targetScrollElements = [navigationScroll, searchScroll]
const navigationButton = document.querySelector(
  '.header-button[data-navigation]'
)

if (navigation && navigationButton) {
  navigationButton.addEventListener('click', () => {
    document.documentElement.classList.toggle('is-menu')
    if (document.documentElement.classList.contains('is-menu')) {
      lock(targetScrollElements)
    } else {
      unlock(targetScrollElements)
    }
  })
}

const collapseExpander = (expander) => {
  expander.classList.remove('is-open', 'is-category')
  expander
    .querySelectorAll('.navigation-category.is-open')
    .forEach((category) => category.classList.remove('is-open'))
}
if (navigation) {
  navigation.querySelectorAll('.navigation-expander').forEach((expander) => {
    const heading = expander.querySelector('.navigation-expander__heading')
    heading.addEventListener('click', () => {
      Array.from(document.querySelectorAll('.navigation-expander.is-open'))
        .filter((item) => item !== expander)
        .forEach(collapseExpander)

      expander.classList.toggle('is-open')
      if (!expander.classList.contains('is-open')) {
        collapseExpander(expander)
      }
    })
  })

  navigation
    .querySelectorAll('div.navigation-expander__item')
    .forEach((category) => {
      const { expand } = category.dataset
      const parent = category.closest('.navigation-expander')
      category.addEventListener('click', () => {
        parent.classList.add('is-category')
        const category = parent.querySelector(
          `.navigation-category[data-expand="${expand}"]`
        )
        if (category) {
          category.classList.add('is-open')
        }
      })
    })

  navigation
    .querySelectorAll('.navigation-category__heading')
    .forEach((backButton) => {
      const category = backButton.closest('.navigation-category')
      const expander = backButton.closest('.navigation-expander')
      backButton.addEventListener('click', () => {
        expander.classList.remove('is-category')
        category.classList.remove('is-open')
      })
    })
}
